const reportErrorService = (manageHandleErrorService, customErrors) => {
    // ideally to merge customReason into manageHandleErrorService, Angular didn't like it,
    // passing by angular.value
    customErrors['name.*must be unique'] = 'Name must be unique';

    return Object.assign({} , manageHandleErrorService);
}

angular
    .module('qkr.merchant.reports')
    .factory('reportsErrorService', reportErrorService);




// WEBPACK FOOTER //
// ./src/reports/services/reports.error.service.js